export default {
  Usage: 'usage',
  Purchase: 'purchase',
}
